import { GET_CLIENT_SORTING_ORDER_LIST } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CLIENT_SORTING_ORDER_LIST: {
      return { ...state, ...{ list: action.clientSortingOrder } };
    }
    default:
      return state;
  }
}
